﻿import window from 'window';
import document from 'document';
import { scrollTop } from './scroll-top';

export const scroller = (() => {
    const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
    const main = document.querySelector('main');

    const getScrollOffset = () => main ? main.offsetTop : 0;

    const scrollToElement = (element, callback, offsetTop = 0) => {
        const scrollOffset = getScrollOffset();
        const noop = () => { };

        if (isSmoothScrollSupported) {
            function scrollTo(offset, callback = noop) {
                const onScroll = function () {
                    const scrollTop = window.scrollTop || window.pageYOffset;

                    // run callback when current position has further scroll
                    if (scrollTop <= offset) {
                        window.removeEventListener('scroll', onScroll);
                        callback();
                    }
                }
                window.addEventListener('scroll', onScroll);
                onScroll();
                window.scrollTo({
                    top: offset,
                    behavior: 'smooth'
                });
            }

            const topOfElement = element.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - scrollOffset;

            scrollTo(topOfElement - offsetTop, callback);

        } else {
            const to = document.querySelector(element).offset().top - scrollOffset - offsetTop;
            scrollTop.scrollTo({
                to: to,
                easing: window.easings.easeOutBounce,
                duration: 500,
                callback: callback
            });
        }
    };

    const isScrolledIntoView = (element, offsetTop = 0) => {
        const rect = element.getBoundingClientRect();
        const scrollOffset = getScrollOffset() + offsetTop;
        const isInView = (rect.top >= scrollOffset) && (rect.bottom <= window.innerHeight);
        return isInView;
    };

    return {
        scrollToElement,
        isScrolledIntoView
    };
})();